const SPARKLINE_COLOR = "#2a78d6";
const WIDTH = 100;
const HEIGHT = 28;
const STROKE_INSET = 2;

export type SparklinePoint = { label: string; value: number };

export function Sparkline({
  points,
  formatValue,
}: {
  points: SparklinePoint[];
  formatValue: (value: number) => string;
}) {
  if (points.length < 2) return null;
  const values = points.map((point) => point.value);
  const lowest = Math.min(0, ...values);
  const highest = Math.max(...values);
  const range = highest - lowest || 1;
  const step = WIDTH / (points.length - 1);
  const xOf = (index: number) => index * step;
  const yOf = (value: number) =>
    STROKE_INSET + (1 - (value - lowest) / range) * (HEIGHT - 2 * STROKE_INSET);
  const line = points
    .map(
      (point, index) =>
        `${index === 0 ? "M" : "L"}${xOf(index)},${yOf(point.value)}`,
    )
    .join(" ");

  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio="none"
      className="h-7 w-full overflow-visible"
      role="img"
      aria-label="Andamento nel periodo"
    >
      <path
        d={`${line} L${WIDTH},${HEIGHT} L0,${HEIGHT} Z`}
        fill={SPARKLINE_COLOR}
        fillOpacity={0.08}
      />
      <path
        d={line}
        fill="none"
        stroke={SPARKLINE_COLOR}
        strokeWidth={1.5}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
      />
      {points.map((point, index) => (
        <rect
          key={point.label}
          x={xOf(index) - step / 2}
          y={0}
          width={step}
          height={HEIGHT}
          fill="transparent"
        >
          <title>{`${point.label}: ${formatValue(point.value)}`}</title>
        </rect>
      ))}
    </svg>
  );
}
